var app = angular.module("leonardo");

var PortfolioPropertySelectorDialog = function($scope, PropertyService, FormErrorsService) {

  $scope.data = {
    portfolios: [],
    properties: []
  };

  $scope.propertiesAvailable = $scope.ngDialogData.propertiesAvailable;
  $scope.portfoliosAvailable = $scope.ngDialogData.portfoliosAvailable;
  $scope.mode = $scope.ngDialogData.mode ?  $scope.ngDialogData.mode : 'template';

  $scope.template = $scope.ngDialogData.template;
  $scope.account = $scope.ngDialogData ? $scope.ngDialogData.account : null;
  $scope.clone = $scope.ngDialogData.clone;

  $scope.showProperties = function() {
    return isNull($scope.template) || (!$scope.template.root_group && isNull($scope.template.group));
  };

  $scope.removeProperties = function() {
    var properties_valid = [];
    angular.forEach($scope.propertiesAvailable, function(value) {
      if (_.contains($scope.data.properties, value.id)) {
        if (!_.contains($scope.data.portfolios, value.portfolio)) {
          properties_valid.push(value.id);
        }
      }
    });
    $scope.data.properties = properties_valid;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if (isNull($scope.template) || (!$scope.template.root_group && isNull($scope.template.group))) {
      if(!$scope.data.type && ($scope.data.portfolios.length === 0) && ($scope.data.properties.length === 0)) {
        return;
      }
      if ($scope.ngDialogData && $scope.ngDialogData.noProperties) {
        $scope.removeProperties();
      }
    }
    if($scope.template){
      $scope.data.name = $scope.template.name;
    }
    $scope.confirm($scope.data);
  };
};

app.controller('PortfolioPropertySelectorDialog', ['$scope', 'PropertyService', 'FormErrorsService', PortfolioPropertySelectorDialog]);
